module.exports = ".all-page {\n    height: 80vh;\n    width: 100%;\n}"